import * as React from "react";
import { mergeOverrides } from "baseui";
import { Block } from "../Block";

type TBlockProps = React.ComponentProps<typeof Block>;
type TSektionProps = {
  compact?: boolean;

  overrides?: any;
} & TBlockProps;

const defaultSpacing = ["scale900", "scale900", "scale1200", "scale1600"];
const compactSpacing = "scale800";

// eslint-disable-next-line react/display-name
const Sektion = React.forwardRef<HTMLDivElement, TSektionProps>(
  ({ children, compact, overrides = {}, ...props }: TSektionProps, ref) => (
    <Block
      as="section"
      // With display="flow-root" to invoke 'block formatting context'
      // (This allows the nested margins to behave as desired)
      display="flow-root"
      overrides={mergeOverrides({ Block: { props: { ref } } }, overrides)}
      {...props}
    >
      <Block
        marginTop={compact ? compactSpacing : defaultSpacing}
        marginBottom={compact ? compactSpacing : defaultSpacing}
      >
        {children}
      </Block>
    </Block>
  )
);

export { Sektion };
